import { Injectable, inject } from '@angular/core';

import { FilterModel } from '@core/models/filter.model';
import { FilterApiService } from '@core/services/api/filter.api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';

import {
  CreateAction,
  CreateFailureAction,
  CreateSuccessAction,
  DeleteAction,
  DeleteSuccessAction,
  FilterActionTypes,
  SaveAction,
  SaveFailureAction,
  SaveSuccessAction,
  SearchFailureAction,
  SearchSuccessAction,
} from './filter.actions';
import * as fromRoot from '../../redux/index';

@Injectable()
export class FilterEffects {
  private store = inject<Store<fromRoot.State>>(Store);
  private actions$ = inject(Actions);
  private filterService = inject(FilterApiService);

  search$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FilterActionTypes.SearchAction),
      switchMap(() =>
        this.filterService.findAll().pipe(
          map(filters => new SearchSuccessAction(filters)),
          catchError(errors => of(new SearchFailureAction(errors)))
        )
      )
    )
  );

  save$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FilterActionTypes.SaveAction),
      map((action: SaveAction) => action.payload),
      switchMap((model: FilterModel) =>
        this.filterService.save(model).pipe(
          map(filter => new SaveSuccessAction(filter)),
          catchError(errors => of(new SaveFailureAction(errors)))
        )
      )
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FilterActionTypes.CreateAction),
      map((action: CreateAction) => action.payload),
      switchMap((model: FilterModel) =>
        this.filterService.create(model).pipe(
          map(filter => new CreateSuccessAction(filter)),
          catchError(errors => of(new CreateFailureAction(errors)))
        )
      )
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FilterActionTypes.DeleteAction),
      map((action: DeleteAction) => action.payload),
      switchMap((model: FilterModel) =>
        this.filterService.delete(model).pipe(
          map(_ => new DeleteSuccessAction(model)),
          catchError(errors => of(new SaveFailureAction(errors)))
        )
      )
    )
  );
}
